import { AccessLevel, Route } from 'src/routes/Route'

export const ImportContactsRoute = Route({
  path: '/import-contacts',
  accessLevel: AccessLevel.PRIVATE,
})
export type ImportContactsRoute = Route<typeof ImportContactsRoute>
